import React from 'react';

import useLayout from '@context/layout/useLayout';
import { bool } from 'prop-types';
import MainPanel from './MainPanel';
import BottomPanel from './BottomPanel';
import RightNav from './RightNav';
import RightPanel from './RightPanel/RightPanel';
import TradePanel from './TradePanel';
import TopNav from './TopNav';

import useTradePanelAutoShow from './hooks/useTradePanelAutoShow';
import { styPanelWrapper, styPanelContainer, styPanelRoot, styLayoutContainer } from './style';

const Layout = ({ withBottomPanel = true, profileOnly = false }) => {
  useTradePanelAutoShow();
  const { tradePanel, rightPanel } = useLayout();

  return (
    <div className={styLayoutContainer}>
      <TopNav />
      <div className={styPanelWrapper}>
        <div className={styPanelContainer}>
          <div className={styPanelRoot}>
            <MainPanel withBottomPanel={withBottomPanel} />
            <BottomPanel withBottomPanel={withBottomPanel} />
            {tradePanel.isVisible && <TradePanel />}
            {rightPanel.isVisible && <RightPanel />}
          </div>
        </div>
        <RightNav profileOnly={profileOnly} />
      </div>
    </div>
  );
};

Layout.propTypes = {
  withBottomPanel: bool,
  profileOnly: bool,
};

Layout.defaultProps = {
  withBottomPanel: true,
  profileOnly: false,
};

export default Layout;
